import { useSearchParams } from "react-router"
import { useArticleAudit } from "../../../api/articlesApi"
import { useTemplateSettings } from "../../../api/templateSettingsApi"
import { AuditTrail } from "../../shared/AuditTrail"

export function ArticleAuditSection() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useArticleAudit(id, { limit: 20 })
  // The org may call product groups something else; the list and the fields
  // section already read this, so the audit line should not be the one place
  // that still says "Produktgruppe". Cached query, no extra request here.
  const { data: templateSettings } = useTemplateSettings()

  const events = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <AuditTrail
      events={events}
      isLoading={isLoading}
      hasMore={!!hasNextPage}
      isFetchingMore={isFetchingNextPage}
      onLoadMore={fetchNextPage}
      fieldLabels={{ product_group: templateSettings?.productGroupLabel }}
    />
  )
}
